module.exports = __webpack_public_path__ + "img/rotork_r.79940a75.png";